import { rspackPlugin } from './index.ts';

export default rspackPlugin;
